import { Component } from "@angular/core";
import { EventsService } from "../../services/events.service";
import { CommonModule } from "@angular/common";
import { NgOptimizedImage } from "@angular/common";

@Component({
  standalone: true,
  imports: [CommonModule, NgOptimizedImage],
  selector: "app-spinner",
  templateUrl: "./spinner.component.html",
  styleUrls: ["./spinner.component.scss"],
})
export class SpinnerComponent {
  constructor(public eventsService: EventsService) {}
}
